import { useEffect, useRef } from 'react';
import { usePutReadMessage } from 'services/chat';
import { IChatMessage } from 'services/chat/types';

export const useReadMessages = (
  data: IChatMessage[] | undefined,
  senderId: string,
  refetch?: () => void,
) => {
  const { mutateAsync } = usePutReadMessage();
  // Używamy Ref do przechowywania IDs, które SĄ W TRAKCIE wysyłania
  const pendingIds = useRef(new Set<string>());

  useEffect(() => {
    // 1. Warunki wyjścia - bardzo ważne
    if (!data || data.length === 0) return;

    // 2. Filtrujemy tylko te, których NIE ma w pendingIds i są nieprzeczytane
    const unreadIds = data
      .filter(
        msg =>
          msg.senderId === senderId &&
          msg.readAt === null &&
          !pendingIds.current.has(msg.id),
      )
      .map(msg => msg.id);

    if (unreadIds.length === 0) return;

    // 3. Natychmiast dodajemy do pending, żeby kolejny render (np. z refetch) ich nie ruszył
    unreadIds.forEach(id => pendingIds.current.add(id));

    const markAsRead = async () => {
      try {
        // Lepiej wysłać to jako jeden request, jeśli API na to pozwala (np. batch update)
        // Jeśli nie, robimy Promise.all
        await Promise.all(unreadIds.map(id => mutateAsync({ messageId: id })));

        // 4. Dopiero po sukcesie wszystkich, jeśli trzeba, odświeżamy
        if (refetch) {
          refetch();
        }
      } catch (error) {
        // W razie błędu usuwamy z pending, żeby można było spróbować ponownie
        unreadIds.forEach(id => pendingIds.current.delete(id));
        console.error('Failed to mark messages as read', error);
      }
    };

    markAsRead();

    // Dodajemy tylko niezbędne zależności.
    // senderId i data są kluczowe. mutateAsync zazwyczaj jest stabilne, ale zależy od biblioteki.
  }, [data, senderId]);
};
